var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrightnessContrast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.008,
    height: 30.008,
    viewBox: "0 0 30.008 30.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M13.932 0h2.143v3.215h-2.143z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M26.793 13.932h3.215v2.143h-3.215z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35",
    d: "M13.932 26.793h2.143v3.215h-2.143z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M0 13.932h3.215v2.143H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "m3.697 5.235 1.516-1.517 2.273 2.274-1.52 1.516z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "m22.506 5.98 2.273-2.272 1.516 1.516-2.273 2.273z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "m22.508 24.024 1.517-1.516 2.272 2.274-1.515 1.516z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40",
    d: "m3.719 24.788 2.272-2.282 1.511 1.525L5.23 26.3l-1.511-1.511z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41",
    d: "M15.004 6.43a8.574 8.574 0 1 0 8.574 8.574 8.574 8.574 0 0 0-8.574-8.574zm0 15a6.43 6.43 0 1 1 0-12.86z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightnessContrast);
export default __webpack_public_path__ + "static/media/brightness-contrast.143f4d1abed2a415f8768cb722ab84e3.svg";
export { ForwardRef as ReactComponent };